import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DxDataGridComponent, DxFormComponent, DxTemplateModule } from 'devextreme-angular';
import { SelectionChangedEvent } from 'devextreme/ui/data_grid';
import { AccountingService } from 'src/app/accounting/accounting.service';
import { Location } from '@angular/common';
import { ToastService } from 'src/app/core/services/toast.service';
import { PopupService } from 'src/app/core/services/popup.service';
import { TranslationService } from 'src/app/core/services/translation.service';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { NaivgationService } from 'src/app/core/services/navigation.service';
import { ClickEvent } from 'devextreme/ui/button';
import { formatMessage } from 'devextreme/localization';
import ODataStore from 'devextreme/data/odata/store';
import { ACCOUNTS_PAYABLE_INVOICE_ODATA_URL, ACCOUNTS_RECEIVABLE_INVOICE_ODATA_URL } from 'src/app/accounting/accounting-model';
// import DataSource from 'devextreme/data/data_source';
// import { ToISODate } from 'src/app/Utils/date-time.helper';
// import { ProductionService } from '../../production.service';
// import { WORKSTATION_ODATA_URL } from '../../production-model';
import dxSelectBox, { InitializedEvent, Properties as SelectBoxProperties } from 'devextreme/ui/select_box';
import { IsNullOrEmtpy } from 'src/app/Utils/utils';
import { ProductionService } from 'src/app/production/production.service';
import DataSource from 'devextreme/data/data_source';
import { PARTS_ODATA_URL, TIME_PERIOD_TYPE_ODATA_URL } from 'src/app/sales/sales-model';
import { NameMaxLength } from 'src/app/Utils/constant';
@Component({
  selector: 'app-edit-process-routing-import',
  templateUrl: './edit-process-routing-import.component.html',
  styleUrls: ['./edit-process-routing-import.component.scss']
})
export class EditProcessRoutingImportComponent {

  @ViewChild(DxDataGridComponent)
  grid!: DxDataGridComponent;

  @ViewChild(DxFormComponent)
  public form!: DxFormComponent;

  @Input()
  public popupVisible: boolean = false;

  @Input()
  public importedProcessRouting: any;

  @Input()
  public allWorkStationsWithGroup: any[] = [];

  @Output()
  public onSave: EventEmitter<unknown> = new EventEmitter();

  @Output()
  public onCancel: EventEmitter<unknown> = new EventEmitter();

  ngOnInit() {
    this.navigationService.isFormDirty = true;
  }

  public isSaving = false;
  public nameMaxLength = NameMaxLength;
  public bulkEditPopupVisible: boolean = false;
  public bulkEditData: any = {
    Name: null,
    PartName: null,  
    Type: null,
    WorkStation: null,
    CycleTimePeriodType: null,
    SetupTimePeriodType: null
  };
  constructor(
    private router: Router,
    private productionService: ProductionService,
    private route: ActivatedRoute,
    private location: Location,
    private toastService: ToastService,
    private popupService: PopupService,
    public translationService: TranslationService,
    private spinnerService: SpinnerService,
    private navigationService: NaivgationService
  ) { }

  public selectedRowsData: any[] = [];

  public onSelectionChanged = (e: SelectionChangedEvent) => {
    this.selectedRowsData = e.selectedRowsData;
  }

  public onEditorPreparing = (e: any) => {

    if (e.dataField === 'Name' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.Name = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('Name');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }

        const wrongColumnIndexOfRouting = e.row.data.WrongColumns.indexOf('ProcessRoutingStep');
        if (wrongColumnIndexOfRouting !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndexOfRouting, 1);
        }
      };
    }

    if (e.dataField === 'PartName' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.PartName = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('PartName');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }

        const wrongColumnIndexOfRouting = e.row.data.WrongColumns.indexOf('ProcessRoutingStep');
        if (wrongColumnIndexOfRouting !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndexOfRouting, 1);
        }
      };
    }

    if (e.dataField === 'Type' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.Type = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('Type');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }
      };
    }

    // if(e.dataField == 'WorkStation' && e.parentType === 'dataRow') {
    //   e.editorOptions.onValueChanged = (args: any) => {        
    //     e.row.data.WorkStation = args.value;

    //     //Remove it from WrongColumns
    //     const wrongColumnIndex = e.row.data.WrongColumns.indexOf('WorkStation');
    //     if (wrongColumnIndex !== -1) {
    //       e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
    //     }  
    //   };         
    // }

    if (e.dataField === 'Operation' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.Operation = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('Operation');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }
      };
    }

    if (e.dataField === 'Priority' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.Priority = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('Priority');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }

        const wrongColumnIndexOfRouting = e.row.data.WrongColumns.indexOf('ProcessRoutingStep');
        if (wrongColumnIndexOfRouting !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndexOfRouting, 1);
        }
      };
    }

    if (e.dataField === 'CycleTime' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.CycleTime = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('CycleTime');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }
      };
    }

    if (e.dataField === 'CycleTimePeriodType' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.CycleTimePeriodType = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('CycleTimePeriodType');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }
      };
    }

    if (e.dataField === 'SetupTime' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.SetupTime = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('SetupTime');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }
      };
    }

    if (e.dataField === 'SetupTimePeriodType' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.SetupTimePeriodType = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('SetupTimePeriodType');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }
      };
    }

    if (e.dataField === 'Instruction' && e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data.Instruction = args.value;

        //Remove it from WrongColumns
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf('Instruction');
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }
      };
    }

    if (e.parentType === 'dataRow') {
      e.editorOptions.onValueChanged = (args: any) => {
        e.row.data[e.dataField] = args.value;

        // Remove from WrongColumns if needed
        const wrongColumnIndex = e.row.data.WrongColumns.indexOf(e.dataField);
        if (wrongColumnIndex !== -1) {
          e.row.data.WrongColumns.splice(wrongColumnIndex, 1);
        }

        // Sync the change to importedProcessRouting
        const index = this.importedProcessRouting.findIndex((row: any) => row.Id === e.row.data.Id);
        if (index !== -1) {
          this.importedProcessRouting[index][e.dataField] = args.value;
        }
      };
    }

  }

  onCellPrepared(e: any) {
    //Highlight wrong cell all
    if (e.rowType === 'data' && e.data && e.data.WrongColumns) {
      if (e.data.WrongColumns.includes(e.column.dataField)) {
        e.cellElement.style.backgroundColor = '#f8d7da';
        e.cellElement.style.color = '#721c24';
      }
    }
  }


  public formatText(text: string) {
    return formatMessage(text);
  }

  public cancelClick() {
    if (this.onCancel.observers.length > 0) {
      this.onCancel?.emit();
    }
  }

  public onCancelClicked = (e: ClickEvent) => {

    if (this.navigationService.isFormDirty) {
      let textMessage = this.translationService.translate('popup_message_unsave_changes_confirmation');
      this.popupService.confirm({
        message: textMessage,
        visible: true,
        onNoClicked: () => {
          this.popupService.close();
        },
        onYesClicked: (e: any) => {
          this.popupService.close();
          this.navigationService.isFormDirty = false;
          this.cancelClick();
        },
        title: this.translationService.translate('popup_title_confirm'),
      });
    }
  };

  public onSaveClicked = (e: any) => {
    if (this.selectedRowsData?.length > 0) {
      let combinedMessage = '';

      // let uniqueRows: any[] = [];
      // let seenIds = new Set();

      for (const row of this.selectedRowsData) {
        if (row.WrongColumns.includes('Name') || IsNullOrEmtpy(row.Name)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_name")) + '\n';
        }
        if (row.WrongColumns.includes('PartName') || IsNullOrEmtpy(row.PartName)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_part_name")) + '\n';
        }
        if (row.WrongColumns.includes('Type') || IsNullOrEmtpy(row.Type)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_type")) + '\n';
        }
        if (row.WrongColumns.includes('WorkStation') || IsNullOrEmtpy(row.WorkStation)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("filter_workstation")) + '\n';
        }
        if (row.WrongColumns.includes('Operation') || IsNullOrEmtpy(row.Operation)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_operation")) + '\n';
        }
        if (row.WrongColumns.includes('Priority') || IsNullOrEmtpy(row.Priority)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_priority")) + '\n';
        }
        if (row.WrongColumns.includes('CycleTime') || row.CycleTime <= 0) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_cycle_time")) + '\n';
        }
        if (row.WrongColumns.includes('CycleTimePeriodType') || IsNullOrEmtpy(row.CycleTimePeriodType)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_cycle_time_period_type")) + '\n';
        }
        if (row.WrongColumns.includes('SetupTime') || IsNullOrEmtpy(row.SetupTime)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_setup_time")) + '\n';
        }
        if (row.WrongColumns.includes('SetupTimePeriodType') || IsNullOrEmtpy(row.SetupTimePeriodType)) {
          combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_setup_time_period_type")) + '\n';
        }
        if (row.WrongColumns.includes('ProcessRoutingStep')) {
          combinedMessage += this.translationService.translate("validation_message_exists", this.translationService.translate("grid_column_process_routing_step")) + '\n';
        }
        // if(row.WrongColumns.includes('Instruction') || IsNullOrEmtpy(row.Instruction)) {
        //   combinedMessage += this.translationService.translate("validation_message_required", this.translationService.translate("grid_column_instruction")) + '\n';
        // }
        // const id = row.Id;
        // if (!seenIds.has(id)) {
        //   uniqueRows.push(row);
        //   seenIds.add(id);
        // }

      }

      if (combinedMessage !== '') {
        this.toastService.warning(combinedMessage.trim());
        return;
      }
      else {
        this.spinnerService.showSpinner();
        this.isSaving = true;

        this.toastService.success(this.translationService.translate("toast_message_process_routing_getting_added_wait"));
        return this.productionService.saveImportedProcessRouting(this.selectedRowsData)
          .then((res: any) => {
            this.spinnerService.hideSpinner();
            if (res) {
              let message = this.translationService.translate("toast_message_added", this.translationService.translate("action_import_process_routing"));
              this.toastService.success(message);

              if (this.onSave.observers.length > 0) {
                this.onSave?.emit();
                this.popupService.close();
                this.popupVisible = false;
              }
              else {
                this.router.navigateByUrl(`/production/process/routing`);
              }

            }
          })

      }


    }
    else {
      let message = this.translationService.translate("dialog_message_select_process_routing");
      this.toastService.warning(message);
      return;
    }
  }

  public getWorkStationName() {
    return this.allWorkStationsWithGroup;
  }

  onValueChanged(e: any, rowData: any) {
    rowData.setValue(e.value);
    const wrongColumnIndex = rowData.data.WrongColumns.indexOf('WorkStation');
    if (wrongColumnIndex !== -1) {
      rowData.data.WrongColumns.splice(wrongColumnIndex, 1);
    }
  }

  onValueChangedPart(e: any, rowData: any) {
    rowData.setValue(e.value);
    rowData.data.PartName = e.value;
    const wrongColumnIndex = rowData.data.WrongColumns.indexOf('PartName');
    if (wrongColumnIndex !== -1) {
      rowData.data.WrongColumns.splice(wrongColumnIndex, 1);
    }

    // const latestData = this.grid.instance.getDataSource().items();

    this.spinnerService.showSpinner();
    this.productionService.checkProcessRoutingData(this.importedProcessRouting)
      .then((res: any) => {
        this.spinnerService.hideSpinner();
        this.importedProcessRouting = res;
      });
  }

  public partDataSource = new DataSource({
    store: new ODataStore({
      url: PARTS_ODATA_URL, // Replace with your actual OData URL
      key: "Id",
      version: 4
    }),
    select: ['Name', 'Id']
  });

  public typeDataSource = {
    dataSource: [
      { Id: 1, Name: "Production" },
      { Id: 2, Name: "QC" }
    ]
  };

  onValueChangedType(e: any, rowData: any) {
    rowData.setValue(e.value);
    const wrongColumnIndex = rowData.data.WrongColumns.indexOf('Type');
    if (wrongColumnIndex !== -1) {
      rowData.data.WrongColumns.splice(wrongColumnIndex, 1);
    }
  }

  public cyclePeriodTypeDataSource = new DataSource({
    store: new ODataStore({
      url: TIME_PERIOD_TYPE_ODATA_URL,
      key: "Id",
      version: 4
    }),
    select: ['Name', 'Id']
  });

  onValueChangedCylePeriodType(e: any, rowData: any) {
    rowData.setValue(e.value);
    const wrongColumnIndex = rowData.data.WrongColumns.indexOf('CycleTimePeriodType');
    if (wrongColumnIndex !== -1) {
      rowData.data.WrongColumns.splice(wrongColumnIndex, 1);
    }
  }

  public setupPeriodTypeDataSource = new DataSource({
    store: new ODataStore({
      url: TIME_PERIOD_TYPE_ODATA_URL, // Replace with your actual OData URL
      key: "Id",
      version: 4
    }),
    select: ['Name', 'Id']
  });

  onValueChangedSetupPeriodType(e: any, rowData: any) {
    rowData.setValue(e.value);
    const wrongColumnIndex = rowData.data.WrongColumns.indexOf('SetupTimePeriodType');
    if (wrongColumnIndex !== -1) {
      rowData.data.WrongColumns.splice(wrongColumnIndex, 1);
    }
  }
  public onBulkEditClicked = (): void => {
    if (!this.selectedRowsData || this.selectedRowsData.length === 0) {
      this.toastService.warning(this.translationService.translate("dialog_message_select_process_routing"));
      return;
    }

    this.bulkEditData = {
      Type: null,
      PartName: null, 
      WorkStation: null,
      CycleTimePeriodType: null,
      SetupTimePeriodType: null
    };
    this.bulkEditPopupVisible = true;
  }

  public onBulkEditCancel = (): void => {
    this.bulkEditPopupVisible = false;
  }

  public onBulkEditApply = (): void => {
    if (!this.selectedRowsData || this.selectedRowsData.length === 0) {
      this.toastService.warning(this.translationService.translate("dialog_message_select_process_routing"));
      return;
    }

    // treat a name with only spaces as blank
    if (typeof this.bulkEditData.Name === 'string') {
      this.bulkEditData.Name = this.bulkEditData.Name.trim();
    }

    // only the fields the user filled in
    const fields = Object.keys(this.bulkEditData).filter(k => this.bulkEditData[k]);

    if (fields.length === 0) {
      this.toastService.warning('Please select at least one field to update');
      return;
    }

    let updatedCount = 0;

    this.selectedRowsData.forEach((row: any) => {
      if (!row) return;

      fields.forEach(field => {
        row[field] = this.bulkEditData[field];

        // remove the red highlight for this column
        if (row.WrongColumns) {
          const idx = row.WrongColumns.indexOf(field);
          if (idx !== -1) {
            row.WrongColumns.splice(idx, 1);
          }
        }
      });

      // changing Name also clears the "step already exists" error, same as the cell editor
  // changing Name or PartName also clears the "step already exists" error, same as the cell editor
      if ((fields.includes('Name') || fields.includes('PartName')) && row.WrongColumns) {
        const stepIdx = row.WrongColumns.indexOf('ProcessRoutingStep');
        if (stepIdx !== -1) {
          row.WrongColumns.splice(stepIdx, 1);
        }
}

      updatedCount++;
    });

    this.grid.instance.refresh();

    this.bulkEditPopupVisible = false;
    this.toastService.success(`Successfully updated ${updatedCount} row(s)`);
  }

}
